export default __webpack_public_path__ + "static/media/IKPLogo.5934e5bd.png";